<script type="text/ecmascript-6">
import { h } from 'vue'
import Helper from './helper'

export default {
  name: 'VGrid',
  props: {
    in: {
      type: [Number, String],
      default: null
    },
    element: {
      type: String,
      default: 'div'
    },
    contain: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...Helper
  },
  render: function () {
    return h(
      this.element, {
        class: this.getClass([
          'mt-grid',
          this.rwd('in', 'in'),
          this.contain ? 'contain' : ''
        ])
      },
      this.$slots?.default?.()
    )
  }
}
</script>
